import gql from 'graphql-tag';

export default gql`
  fragment Report on Report {
    name
    description
    available
  }
`;
